import React, { useEffect, useState,useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import Drawer from '@mui/material/Drawer';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FemaleRoundedIcon from '@mui/icons-material/FemaleRounded';
import MaleRoundedIcon from '@mui/icons-material/MaleRounded';
import {GloabalSearchPatient } from '../Services/PatientServicces';
import { GetDashboard } from '../Services/Dashboard';
import Tooltip from '@mui/material/Tooltip';
import SpinnerModal from '../Spinner/SpinnerModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../UI/Layout.css';

import useradd from '../assets/user-add.svg'
import useraddfull from '../assets/user-add-full.svg'

import multiUser from '../assets/multiuser.svg'
import multiUserfull from '../assets/users-full.svg'

import settings from '../assets/settings.svg'
import settingsfull from '../assets/settings-full.svg'

import pending from '../assets/pending.svg'
import pendingfull from '../assets/pendingFull.svg'
import Dashboard from '../assets/Dashboard.svg'
import DashboardFull from '../assets/Dashboardfull.svg'
import report from '../assets/chart-simple.svg'
import reportfull from '../assets/chart-simple-full.svg'

import userlock from '../assets/user-lock.svg'
import tests from '../assets/tests.svg'
import template from '../assets/template-alt.svg'
import logout from '../assets/sign-out-alt.svg'
import Billing from '../assets/invoice.svg'
import Editlab from '../assets/flask.svg'




import { ListItemText } from '@mui/material';
import Logo from './Logo/Logo';

const drawerWidth = '70px';
const bgcolor = '#2c6bd7';
const color = '#ffff'

const AppBar = styled('div')(({ theme }) => ({
  //...theme.mixins.toolbar,
  backgroundColor: '#ffffff',
  boxShadow: 'none',
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dashboardData, setDashboardData] = useState([]);
  const [User_Role, SetUser_Role] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [FirstN, setFirstName] = useState('');
  const [LastN, setLastName] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorsetting, setanchorsetting] = useState(null);

  const [PatientData,setPatientData] = useState([]);
  const [inputdata, setInputData] = useState('');
  const tblRef = useRef(null);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const settingMenuOpen = (event) => setanchorsetting(event.currentTarget);
  const settingMenuClose = () => setanchorsetting(null);
  const HandleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };
 const EditProfileNavigate = () => {
    navigate('/Home/EditLab');
  };
  const GetLabDetails = async () => {
    const LabID = sessionStorage.getItem('LabID');
    const currentDate = new Date();
    const Year = currentDate.getFullYear();
    const response = await GetDashboard(LabID,Year);
    setDashboardData(response);
  };

  useEffect(() => {
    const User_Role = sessionStorage.getItem('User_Role');
    SetUser_Role(User_Role);
    GetLabDetails();
    const FirstName = sessionStorage.getItem('FirstName');
    const LastName = sessionStorage.getItem('LastName');
    setFirstName(FirstName?.charAt(0).toUpperCase());
    setLastName(LastName?.charAt(0).toUpperCase());
  }, []);

  const isActive = (path) => location.pathname === path;

  //================Search patient =============
const handleChange = (e) => {
  const value = e.target.value;
  setInputData(value);
};

const hnadleSearchPatient = async () => {
  setIsLoading(true);
  try {
        if(inputdata != null || inputdata != ""){
          const LabID = sessionStorage.getItem('LabID');
          const result = await GloabalSearchPatient(LabID, inputdata);
              setPatientData(result);
        }

      } catch (error) {
        console.log('error while searching patient', error);
      } finally {
        setIsLoading(false);
      }
};
//===================END==================
////--------------open profile------------

const NavigatetoProfile = (id) =>{
  window.location.href = `/Home/PatientProfile/${id}`;
  setPatientData("");
}
//------------end---------------
  //-------------------Detect clicks outside of the <ul>----------------------
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tblRef.current && !tblRef.current.contains(event.target)) {
        setPatientData("");
      }
    };

    document.addEventListener('mousedown', handleClickOutside); // Listen for mouse click

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  //---------------------END----------------------
  //-----------Long lab name------------
  const getLimitedText = (text, wordLimit) => {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(' ') + '...';
    }
    return text;
  };
  //---------------------END-----------
  return (
    <>
      {isLoading && <SpinnerModal isLoading={isLoading} />}
      <Box sx={{ display: 'flex',boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'}}>
        <CssBaseline />
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            backgroundColor:'#2c6bd7',
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box',backgroundColor:bgcolor,color:color,overflow:'hidden'},
          }}
        >
         <Toolbar sx={{paddingLeft:'20px',paddingRight:'20px',display:'flex',alignItems:'center',justifyContent:'center'}}>
           <Logo width="36px" height="36px"  color="white" />
         </Toolbar>
          <Box>
            {User_Role === 'Admin' && (
              <div className='side-nav-item' onClick={() => navigate('/Home/Dashboard')} disablePadding>

                {isActive('/Home/Dashboard') ?
                 <img className="nav-icon" src={DashboardFull} alt="user" />
                  :
                  <img className="nav-icon" src={Dashboard} alt="user" />
                 }
                   Dashboard
              </div>
            )}
             <div className='side-nav-item'   onClick={() => navigate('/Home/PendingTest')} disablePadding>
                {isActive('/Home/PendingTest') ?
                 <img className="nav-icon" src={pendingfull} alt="user" />
                  :
                  <img className="nav-icon" src={pending} alt="user" />
                 }
                   PendingTest
              </div>
              <div className='side-nav-item'   onClick={() => navigate('/Home/PatientRegistration')} disablePadding>
                {isActive('/Home/PatientRegistration') ?
                 <img className="nav-icon" src={useraddfull} alt="user" />
                  :
                  <img className="nav-icon" src={useradd} alt="user" />
                 }
                   Add Patient
              </div>
              <div className='side-nav-item'   onClick={() => navigate('/Home/PatientList')} disablePadding>
                {isActive('/Home/PatientList') ?
                 <img className="nav-icon" src={multiUserfull} alt="user" />
                  :
                  <img className="nav-icon" src={multiUser} alt="user" />
                 }
                    Patients
              </div>

              {User_Role === 'Admin' && (
              <div className='side-nav-item'   onClick={() => navigate('/Home/Reports')} disablePadding>
                {isActive('/Home/Reports') ?
                 <img className="nav-icon" src={reportfull} alt="user" />
                  :
                  <img className="nav-icon" src={report} alt="user" />
                 }
                  Reports
              </div>
              )}
    {User_Role === 'Admin' && (
              <div className='side-nav-item'   onClick={() => navigate('/Home/labs-Billing')} disablePadding>
                {isActive('/Home/labs-Billing') ?
                 <img className="nav-icon" src={Billing} alt="user" />
                  :
                  <img className="nav-icon" src={Billing} alt="user" />
                 }
                  Billing
              </div>
              )}
           {User_Role === 'Admin' && (
              <div className='side-nav-item'   onClick={settingMenuOpen}  disablePadding>
                {isActive('/Home') ?
                 <img className="nav-icon" src={settingsfull} alt="user" />
                  :
                  <img className="nav-icon" src={settings} alt="user" />
                 }
                  Settings
              </div>
              )}

            <Menu className='menu settings-menu' anchorEl={anchorsetting} open={Boolean(anchorsetting)} onClose={settingMenuClose}>
                <Tooltip title="Tests" placement="right">
                  <MenuItem className="settings-menu-item" sx={{backgroundColor:'#2c6bd7'}}  onClick={() => {navigate('/Home/TestEntry');settingMenuClose();}}>
                   <img className="settings-menu-icon" src={tests} alt="tests" /><br></br>
                     Tests management
                  </MenuItem>
                </Tooltip>
                <Tooltip  title="Template setup" placement="right">
                  <MenuItem className="settings-menu-item" sx={{backgroundColor:'#2c6bd7'}}  onClick={() =>{ navigate('/Home/TemplateSetting');settingMenuClose();}}>
                    <img className="settings-menu-icon" src={template} alt="template" />
                     Template settings
                  </MenuItem>
                </Tooltip>
                  <MenuItem className="settings-menu-item" sx={{backgroundColor:'#2c6bd7'}}  onClick={() =>{ navigate('/Home/User-Management');settingMenuClose();}} >
                    <img className="settings-menu-icon" src={userlock} alt="userlock" />
                    Account management
                  </MenuItem>
                   <MenuItem className="settings-menu-item" sx={{backgroundColor:'#2c6bd7'}}  onClick={() =>{ navigate('/Home/EditLab');settingMenuClose();}} >
                    <img className="settings-menu-icon" src={Editlab} alt="editlab" />
                    Edit Lab details
                  </MenuItem>

            </Menu>

          </Box>
        </Drawer>

        {/* Main Content */}
        <Box className='Horizental-bar' sx={{ flexGrow: 1, position:'fixed',width:'100%' ,zIndex:'999',textAlign:'center',borderBottom:'1px solid #e0e0e0'}}>
          <AppBar sx={{height:'50px'}}>
              <div class=" InputSearch">
                <input
                    class="form-control mr-sm-2" type="search" aria-label="Search"
                    onKeyDown={(e) => { if (e.key === 'Enter') hnadleSearchPatient(); }}
                    onChange={handleChange}
                    placeholder="Search patient by name/contact number"
                    >
                  </input>
              </div>



            {/* </div> */}
            <Avatar className="header-avatar" sx={{ bgcolor: '#2c6bd7', cursor: 'pointer' }} onClick={handleMenuOpen}>
              {FirstN + LastN}
            </Avatar>
            <Menu  anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <Tooltip title="Logout" placement="right">
              <MenuItem onClick={HandleLogout}>
                 <img src={logout} alt="user" width="24" height="24" style={{filter: 'invert(1)'}} />
              </MenuItem>
              </Tooltip>
            </Menu>
          </AppBar>
            {
              PatientData.length > 0 && (
                <div className='list-table'>
                   <table ref={tblRef}   className='search-tbl table'>
                   <tbody>
                   {PatientData.map((item, index) => (
                     <tr className='common-FontSize-small common-FontFamily common-FontWeight'
                     key={index} onClick={() => NavigatetoProfile(item.patientID) }>
                      <td>
                        <span className='d-flex'>
                           <span><h6> {item.patientName.toUpperCase()}  <span className='common-FontSize-small'>({item.age} Year)</span></h6> </span> 
                        </span>
                        <span><PhoneAndroidRoundedIcon sx={{fontSize:'20px'}} />{item.contactNumber}</span>
                      </td>
                    </tr>
                  ))}
                   </tbody>
                </table>
                </div>
              

              )
            }

       </Box>
      </Box>
    </>
  );
};

export default Layout;